import React, { useEffect, useState } from 'react'
import { cashmoneyhelper, InfoBoxLoader, Explination } from '@enkla-gui'

export default function InfoBox({
  border,
  subtitle,
  title,
  explination = false,
  link,
  click = false,
  icon = 'fa-info',
  hidden = false,
  status = 'default',
  transform = false,
  loading = false
}) {
  const _transform = text => {
    if (typeof text !== 'string') return text
    switch (transform) {
      case 'currency':
        return cashmoneyhelper.format(text)
      default:
        return text
    }
  }

  return (
    <div onClick={_ => click && click()} hidden={hidden} class={link || click ? 'col component_InfoBox info-box-clickable' : 'col component_InfoBox'} >
      <div class='card'>
        <div class={`card-body`}>
          {loading && <InfoBoxLoader />}
          {!loading && (
            <div class='col infobox-wrapper' onClick={() => link ? window.location.hash = link.href : ''}>
              <div>
                <span class='card-title text-light'>
                  {title} {explination && <Explination tip={explination} />}
                </span>
                <h5 class='card-subtitle text'>{_transform(subtitle)}</h5>
              </div>

              <div class='infobox-icon'>
                <div class={`card-display-icon-wrapper ${status}`}>
                  <i class={`fa fa-fw ${icon}`} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div >
  )
}
